module.exports = __webpack_public_path__ + "static/media/liquor.e277d573.svg";